import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { Publisher } from '../model/publisher.class';
import { ActivatedRoute, Router } from '@angular/router';
import { ShaService} from '../services/sha.service';

@Component({
    selector: 'app-user-update',
    templateUrl: './user.update.component.html'
})
export class UserUpdateComponent {

    public constPublisher: Boolean = false;
    public user: User;
    public password: string;
    public passwordRepeat: string;
    public oldMail: string;
    public publishers: Publisher[];
    public mailchecked = false;
    public shaService: ShaService;

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['userId'], 'user').subscribe(user => {
                    this.user = user as User;
                    this.oldMail = this.user.mail;
                    if (userService.user.userType === userService.Admin) {
                        userService.getPublishersWithout(userService.user.publisher.publisherId).subscribe(data => {
                            this.publishers = data as Publisher[];
                            this.publishers.forEach(publisher => {
                                if (publisher.publisherId === this.user.publisher.publisherId) {
                                    this.user.publisher = publisher;
                                }
                            });
                        });
                    }
                });
            });

    }

    updateUser() {
        this.message = '';
        if (this.password === this.passwordRepeat) {
            if (this.user.mail === this.oldMail) {
                this.update();
            } else {
                this.userService.checkMail(this.user.mail).subscribe(
                    (data) => {
                        if (data as Boolean) {
                            this.mailchecked = true;
                        } else {
                            this.update();
                        }
                    },
                    (err) => {
                       this.message = 'Ungültige Mailadresse';
                    });
            }
        }
    }

    update() {
        this.mailchecked = false;
        if (this.password) {

            this.shaService = new ShaService();
            let hashedPassword = this.shaService.SHA256(this.password);
            this.user.password = hashedPassword;
        }
        this.userService.update(this.user, 'user')
            .subscribe(() => {
                if (this.userService.user.userId === this.user.userId) {
                    this.userService.user = this.user;
                }
                this.router.navigate(['/publisher/detail', this.user.publisher.publisherId]);
            },
            (err) => {
                this.message = 'Alle Pflichtfelder ausfüllen!';
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/userUpdate/user.update.component.ts